import type { AxiosInstance } from 'axios'
import type { IFactoryFunctionRequest, IFactoryResponse } from '@bc-library/interface'
import { EMethod } from '@bc-library/interface'
import useAxios from '@/services/api/useAxios'
import { API_MAIN_VERSION, BASE_URL } from '@/config/constantes'

const resource = 'objectives'

const getResource = (axios: IFactoryFunctionRequest<Array<any>, any>) => ({
  resourceId,
  year,
  type,
}: { resourceId: string, year: number, type?: string }) => {
  return axios({
    method: EMethod.get,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/resource/${resourceId}`,
    query: {
      year,
      ...(type ? { type } : {}),
    },
  })
}

const createObjective = (axios: IFactoryFunctionRequest<any, any>) => (objective : any ) => {
  return axios({
    method: EMethod.post,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}`,
    data: objective,
  })
}

const updateObjective = (axios: IFactoryFunctionRequest<any, any>) => (objective : any ) => {
  return axios({
    method: EMethod.put,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/${objective._id}`,
    data: objective,
  })
}

const deleteObjective = (axios: IFactoryFunctionRequest<any, any>) => ({ idToDelete }: { idToDelete: string }) => {
  return axios({
    method: EMethod.delete,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/${idToDelete}`,
  })
}

export default (axios: AxiosInstance) => ({
  getResource: getResource(useAxios(axios)),
  createObjective: createObjective(useAxios(axios)),
  updateObjective: updateObjective(useAxios(axios)),
  deleteObjective: deleteObjective(useAxios(axios)),
})
